export { default } from './Button';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Button/index.js
// module id = 116
// module chunks = 2